/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aifeatureformat2Inputs */

const en_aifeatureformat2 = /** @type {(inputs: Aifeatureformat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format adjustment`)
};

const de_aifeatureformat2 = /** @type {(inputs: Aifeatureformat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format anpassen`)
};

/**
* | output |
* | --- |
* | "Format adjustment" |
*
* @param {Aifeatureformat2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aifeatureformat2 = /** @type {((inputs?: Aifeatureformat2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aifeatureformat2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aifeatureformat2(inputs)
	return de_aifeatureformat2(inputs)
});
export { aifeatureformat2 as "aiFeatureFormat" }